"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineItemAutomationComponent = void 0;
const core_1 = require("@angular/core");
const lineitem_automation_service_1 = require("./lineitem-automation.service");
const notification_service_1 = require("./notification.service");
const notifier_service_1 = require("./notifier.service");
const user_service_1 = require("./user.service");
let LineItemAutomationComponent = class LineItemAutomationComponent {
    constructor(_lineItemAutomation, _talk, _notifier, _user) {
        this._lineItemAutomation = _lineItemAutomation;
        this._talk = _talk;
        this._notifier = _notifier;
        this._user = _user;
        //General initializations
        this.showArgsSelection = false;
        this.showDfpVerificationFailAlert = false;
        this.lineItemAutomationRunning = false;
        this.readyToStartAutomationWizard = false;
        this.selectCompanyValues = null;
        this.loadingCompanyValues = false;
        this.lineItemArgs = { dfpNetworkCode: null, companyId: null, lineItemNamingConvention: 'hb_pb %s', pql: null, activateInactiveValues: false };
        this.lineItemBidderFormValues = { sizes: null, bidderValues: null, adunitNames: null, priceBucketConfig: null, checkSizes: true };
        // custom auto naming convetions for Auto Create Keys
        this.defaultAutoNewNamingConventions = {
            companyId: { key: 'newCompanyNamingConvention', value: 'emx_marketplace' },
            orderIds: { key: 'newOrderNamingConvention', value: 'emx_marketplace' },
            creativeIds: { key: 'newCreativeNamingConvention', value: 'emx_creative' },
            inventoryTargeting: { key: 'newPlacementNamingConvention', value: 'hb_targeting' }
        };
        this.notificationTitle = 'Line Item Automation';
        this.verifyingPqlQuery = false;
        this.pqlInfoUrl = 'https://developers.google.com/doubleclick-publishers/docs/pqlreference#pql-syntax-and-usage';
        this.approvedDfpNetworks = [];
        this.showDfpNetworkSelection = false;
        this.dfpVerificationStatus = null;
        this.verifyingSavedValues = { orderIds: false, creativeIds: false };
        this.runningWizardScripts = {};
        this.pendingTasksPostDfpVerification = [];
        this.socketDisconnected = false;
        this.dfpVerifyRetryNotification = null;
        this.showDfpVerifyRetryNotification = false;
        // default ms to wait for displaying retry notification to user after socket disconnection
        this.dfpVerifyRetryNotificationTime = 30000; // 30 secs
        //Outputs
        this.onDfpVerificationFailAlert = new core_1.EventEmitter();
        this.onTriggerBidderSave = new core_1.EventEmitter();
        this.priceBucketConfig = null;
        this.adUnits = null;
        this.validatedPqlQuery = { str: "", isInvalid: null };
        //Local references for line item args selections tabs
        this.tabsetOpen = {
            orderIds: false,
            creativeIds: false,
            inventoryTargeting: false,
            pbKeyName: true,
            bidderKeyName: false
        };
        //Line arg selection main sources default values
        this.inventoryTargeting = {
            name: 'Inventory Targeting',
            icon: 'fa-wpforms',
            option: '',
            id: 'inventoryTargeting',
            displayPermissions: ['lineitemsMissing'],
            customClass: '',
            selectedValues: null,
            selectedModeOption: '',
            status: { name: null, msg: null },
            selectIdsOptions: [{
                    name: 'Ad Units',
                    readCommand: 'adunits',
                    id: 'adunits',
                    values: null,
                    option: '',
                    selectedValues: null,
                    valuesSelectionType: 'multiple',
                    status: { name: null, msg: null }
                }, {
                    name: 'Placements',
                    readCommand: 'placements',
                    id: 'placements',
                    values: null,
                    option: '',
                    selectedValues: null,
                    valuesSelectionType: 'multiple',
                    status: { name: null, msg: null }
                }],
        };
        this.lineArgsSelections = [
            {
                name: 'Creatives',
                readCommand: 'creatives',
                id: 'creativeIds',
                icon: 'fa-file-picture-o',
                option: '',
                values: null,
                selectedValues: null,
                valuesSelectionType: 'multiple',
                displayPermissions: ['lineitemsMissing'],
                customClass: '',
                useExistingValues: false, //The values currently saved on DB will be used
                status: { name: null, msg: null } //Represents the current status based on socket events
            },
            {
                name: 'Orders',
                option: '',
                icon: 'fa-file-text-o',
                displayPermissions: ['lineitemsMissing'],
                customClass: '',
                readCommand: 'orders',
                id: 'orderIds',
                values: null,
                selectedValues: null,
                valuesSelectionType: 'multiple',
                status: { name: null, msg: null } //Represents the current status based on socket events
            },
            {
                name: 'Bidder Key Name',
                id: 'bidderKeyName',
                displayPermissions: ['bidderKeyMissing', 'bidderValuesMissing', 'lineitemsMissing'],
                customClass: '',
                option: 'existing', // default to bind the existing lineItemArgs value
                icon: 'fa-file-text-o',
                valuesSelectionType: 'input'
            },
            {
                name: 'Price Buckets Key Name',
                id: 'pbKeyName',
                displayPermissions: ['lineitemsMissing'],
                customClass: '',
                option: 'existing', // default to bind the existing lineItemArgs value
                icon: 'fa-file-text-o',
                valuesSelectionType: 'input'
            }
        ];
        this.lineItemArgsSources = {
            "lineArgsSelections": this.lineArgsSelections,
            "inventoryTargetingIdOption": this.inventoryTargeting.selectIdsOptions,
            "inventoryTargeting": this.inventoryTargeting
        };
    }
    ngOnInit() {
        this.registerSocketConnectionObserver();
        this.loadInitialValues();
        this.loadDfpNetworkCodes();
    }
    /**
     * Load the DfpNetwork codes for this organization
     * @returns {Promise<T>}
     */
    loadDfpNetworkCodes() {
        return this._lineItemAutomation.getDfpNetworks(this._user.get().organization.id)
            .then(savedCodes => {
            this.approvedDfpNetworks = (savedCodes && savedCodes.length > 0) ? savedCodes : [];
            return this.approvedDfpNetworks;
        })
            .catch(err => this.logDebugData('Unable to get saved dfp codes', err));
    }
    /**
     * Load initial values from stored line item configs
     */
    loadInitialValues(id) {
        return __awaiter(this, void 0, void 0, function* () {
            let bidder = id || this.bidder;
            try {
                if (bidder) {
                    let foundValues = yield this._lineItemAutomation.getDfpConfigValues(bidder);
                    if (foundValues) {
                        //Update the local line Args
                        this.lineItemArgs = foundValues;
                        this.setDefaultAutoNamingConventions(this.lineItemArgs);
                        this.validatePqlStr(false);
                    }
                }
                else {
                    this.logDebugData('No bidder found to load line item config values');
                }
            }
            catch (err) {
                this.logDebugData('Unable to load initial line automation values.', err.message);
            }
        });
    }
    /**
     * Listen LIA socket connections and error events emitted from LIA service
     */
    registerSocketConnectionObserver() {
        this._lineItemAutomation.onSocketConnectionOrError.subscribe((event) => {
            if (event.type === 'connection') {
                this.socketDisconnected = !event.connected;
                // if the socket go disconnected reset the running state, and notify user
                if (this.socketDisconnected) {
                    if (this.lineItemAutomationRunning) {
                        this._notifier.start({
                            id: this.notificationId,
                            title: this.notificationTitle,
                            status: 'Connection Problem',
                            type: 'warning',
                            message: ' Waiting for LIA service status.'
                        });
                        this.showDfpVerifyRetryNotification = true;
                        this.lineItemAutomationRunning = false;
                    }
                }
                else {
                    // If we conected and no response was received within dfpVerifyRetryNotificationTime ms 
                    // Give the option to the user to attempt a dfp Verification retry
                    // since most likely the LIA job was not able to get restarted
                    if (this.showDfpVerifyRetryNotification && !this.dfpVerifyRetryNotification) {
                        this.dfpVerifyRetryNotification = setTimeout(() => {
                            if (!this.lineItemAutomationRunning) {
                                this._notifier.start({
                                    id: this.notificationId,
                                    title: this.notificationTitle,
                                    status: 'Connection Problem',
                                    type: 'warning',
                                    message: `It seems like we have lost connectivity to the Line Item Automation for bidder ${this.bidder}.`,
                                    htmlContent: `<strong class="text-center">Note: The previously saved config settings will be used on verification.</strong>`,
                                    clickableContent: {
                                        handler: this._lineItemAutomation.retryDfpVerificationHandler(this.bidder, this.notificationId),
                                        text: 'Retry DFP Verification'
                                    }
                                });
                            }
                        }, this.dfpVerifyRetryNotificationTime);
                    }
                }
            }
            else if (event.type === 'error') {
                // update or reset any states for the errored script
                let scriptName = (event.data && event.data.script);
                switch (scriptName) {
                    case 'dfp_verify':
                        this.dfpVerificationStatus = 'Failed';
                        break;
                    case 'wizard':
                    case 'dfp_write':
                        this.lineItemAutomationRunning = false;
                        this.showArgsSelection = false;
                        break;
                    case 'read_dfp':
                        switch (event.data.command) {
                            case 'companies':
                                this.loadingCompanyValues = false;
                                break;
                            case 'pqlValidate':
                                this.verifyingPqlQuery = false;
                                break;
                        }
                        break;
                }
            }
        });
    }
    /**
     * Start the line automation creation for given write script
     * @param {Object<{script:string, args:[Object<{command: string, args:Object}>]}>} data
     */
    startLineItemAutomation(scriptsToRun) {
        // TODO; Maybe Check running dfp verifications 
        if (!scriptsToRun)
            return;
        scriptsToRun.forEach(data => {
            this.logDebugData(`Starting ${data.script}:${data.args.command}`, data);
            this._notifier.start({ id: this.notificationId, title: 'Line Item Automation', status: `Starting line item automation ${data.script}` });
            this._lineItemAutomation.start(data, { fn: this.onSocketEvent, context: this });
            // keep track of the running scripts
            if (typeof this.runningWizardScripts[data.script] === 'number'
                && data.script === 'wizard' && this.runningWizardScripts[data.script] < 1
                || data.script === 'write_dfp' && this.runningWizardScripts[data.script] < 2) {
                this.runningWizardScripts[data.script] += 1;
            }
            else
                this.runningWizardScripts[data.script] = 1;
        });
        this.lineItemAutomationRunning = true;
    }
    /**
     * Public method exposes which triggers the DFP Verify
     */
    startLineItemServiceVerify(data) {
        if (!this.lineItemAutomationRunning) {
            //Update Input args if any was passed as data arg;
            this.adUnits = data ? data.adUnits : this.adUnits;
            this.bidder = data ? data.bidder : this.bidder;
            this.priceBucketConfig = data ? data.priceBucketConfig : this.priceBucketConfig;
            let validatedArgs = this.validateArgs({ bidder: this.bidder, priceBucketConfig: this.priceBucketConfig, adUnits: this.adUnits });
            /// /Make sure we have required args
            if (validatedArgs.missingArgs.length < 1) {
                this.lineItemBidderFormValues.priceBucketConfig = this.priceBucketConfig;
                //Get/parse the adUnits values
                let adUnitsArgs = this.adUnits.reduce((values, ad) => {
                    if (ad.bids) { //Get all the bidder values names
                        ad.bids.forEach(bid => {
                            if (!values.bidderValues.includes(bid.bidder))
                                values.bidderValues.push(bid.bidder);
                        });
                    }
                    if (ad.sizes) { //Get all the sizes
                        ad.sizes.forEach((size) => {
                            // only add the sizes that do not already exist
                            if (!values.sizes.find(v => v.toString() === size.toString()))
                                values.sizes.push(size);
                        });
                    }
                    if (ad.name) { //Get unit names
                        values.adunitNames.push(ad.name);
                    }
                    if (ad.div) { //Get ad unit div ID, included for adUnit names
                        values.adunitNames.push(ad.div);
                    }
                    return values;
                }, { sizes: [], bidderValues: [], adunitNames: [] });
                this.lineItemBidderFormValues.sizes = adUnitsArgs.sizes.length > 0 ? adUnitsArgs.sizes : null;
                this.lineItemBidderFormValues.bidderValues = adUnitsArgs.bidderValues.length > 0 ? adUnitsArgs.bidderValues : null;
                this.lineItemBidderFormValues.adunitNames = adUnitsArgs.adunitNames.length > 0 ? adUnitsArgs.adunitNames : null;
                this.lineItemBidderFormValues.checkSizes = (data && typeof data.sizesChanges !== 'undefined') ? !!data.sizesChanges.length : true;
                //Create a the notification Id to be use to broadcast notifications for this bidder
                this.notificationId = `LIA-${this.bidder}`;
                //Start DFP Verification
                this.startLineItemDfpVerify(this.bidder);
            }
            else {
                this._talk.broadcast(`
          <h3>Missing required values to start Line Item Automation verification:</h3>
          <ul>${validatedArgs.missingArgs.reduce((str, argMissing) => str += `<li>${argMissing}</li>`, "")}</ul>
        `);
            }
        }
    }
    /**
     * Starts the light read for DFP line item  verification
     */
    startLineItemDfpVerify(bidder) {
        return __awaiter(this, void 0, void 0, function* () {
            //1.notify user if missing required args
            // TODO: Check pending DFP verifications running
            if (this.verifyRequiredLineItemArgs(false)) {
                if (this.showArgsSelection) { // reset any existing args selection config to refresh UI
                    this.showArgsSelection = false;
                    this.resetAllConfigSourcesValues();
                }
                let lineItemConfigArgs = null;
                //2.Get line item config values
                //Update/Save config values. If not found it will be created
                try {
                    lineItemConfigArgs = yield this._lineItemAutomation.updateDfpConfigValues(bidder, Object.assign(Object.assign({ bidderValues: this.lineItemBidderFormValues.bidderValues }, this.lineItemArgs), this.getDefaultAutoNamingConventions()));
                    if (!lineItemConfigArgs) { //Make sure we have required config args to start verification
                        this._talk.broadcast('Unable to retrieve required Line Item Config values for verification.');
                        //We must exit since, we can't start verification without config args
                        return;
                    }
                    else {
                        this.logDebugData('updated line item config values', { id: this.notificationId, status: 'LineItemDfpVerify' });
                    }
                }
                catch (err) {
                    this._talk.broadcast('Unable to retrieve required Line Item Config values for verification.');
                    this.logDebugData('startLineItemDfpVerify err', err);
                }
                //Continue to start DFP Verify
                //3.Combine required and optional arguments /Additional Values from form
                let parsedArgs = this.parseDfpVerifyArgs(Object.assign(Object.assign({}, this.validateArgs(lineItemConfigArgs).validArgs), this.validateArgs(this.lineItemBidderFormValues).validArgs));
                let args = {
                    command: "dfpVerify",
                    args: [parsedArgs]
                };
                this.logDebugData('Args for DFP verification', args);
                // Send request for dfp verification
                this._lineItemAutomation.start({
                    args,
                    script: 'dfp_verify',
                    bidder
                }, { fn: this.onDfpVerifyEvent, context: this });
                this.dfpVerificationStatus = 'Starting';
            }
        });
    }
    /**
     * Verify the required and optional args and save to trigger line item creation for required LIA service script
     * @returns {Promise<void>}
     */
    onStartLineItemAutomation() {
        return __awaiter(this, void 0, void 0, function* () {
            let { optionalKeys, requiredKeys } = this.getArgsVerificationKeys();
            if (!requiredKeys)
                return this._talk.broadcast('Unable to get required keys to start Line Item Automation');
            if (this.verifyRequiredLineItemArgs(true, requiredKeys) && this.verifySelectedLineItemArgs([...requiredKeys, ...optionalKeys])) {
                try {
                    // save all the current line item args state and selected config values
                    let saveArgs = Object.assign(Object.assign({}, this.lineItemArgs), this.getSelectedArgsValues([...requiredKeys, ...optionalKeys]));
                    let updatedValues = yield this._lineItemAutomation.updateDfpConfigValues(this.bidder, saveArgs);
                    if (updatedValues) {
                        //Update the current lineArgs with the current updated values
                        this.lineItemArgs = this._lineItemAutomation.copyUpdatedValues(this.lineItemArgs, updatedValues);
                        this.showArgsSelection = false;
                        this.readyToStartAutomationWizard = true;
                        this.startLineItemAutomation(this.getLineItemCreationArgs());
                    }
                }
                catch (err) {
                    this._talk.broadcast(`<h1>Unable to update config values</h1>`);
                }
            }
        });
    }
    /**
     * Get the required and optional keys to verify for wizard and write_dfp
     */
    getArgsVerificationKeys() {
        // Get Wizard keys
        if (this.dfpVerifyResponse && this.dfpVerifyResponse.lineitemsMissing)
            return this.getDefaultVerificationKeys();
        // Keys check for write_dfp
        else if (this.dfpVerifyResponse && this.dfpVerifyResponse.bidderValuesMissing || this.dfpVerifyResponse.bidderKeyMissing)
            return { requiredKeys: ['dfpNetworkCode', 'bidderKeyName', 'bidderValues'], optionalKeys: [] };
        else if (this.dfpVerifyResponse && this.dfpVerifyResponse.sizesMissing)
            return { requiredKeys: ['dfpNetworkCode', 'sizes'], optionalKeys: ['lineItemNamingConvention', 'pql'] };
        return { requiredKeys: null, optionalKeys: null };
    }
    /**
     * Get DFP Verify keys
     */
    getDfpVerifyArgsKeys() {
        return {
            requiredKeys: ['dfpNetworkCode', 'priceBucketConfig', 'bidder'],
            optionalKeys: ['lineItemNamingConvention', 'pql', 'bidderValues', 'pbKeyName', 'bidderKeyName', 'checkSizes', 'sizes']
        };
    }
    /**
     * Parse DFP verify args with only the keys to be included as args for dfpVerification
     */
    parseDfpVerifyArgs(argsToVerify) {
        let { requiredKeys, optionalKeys } = this.getDfpVerifyArgsKeys();
        return [...requiredKeys, ...optionalKeys].reduce((validArgs, validKey) => {
            if (argsToVerify.hasOwnProperty(validKey))
                validArgs[validKey] = argsToVerify[validKey];
            return validArgs;
        }, {});
    }
    /**
     * Default keys verification from available user inputs
     */
    getDefaultVerificationKeys() {
        return {
            requiredKeys: ['dfpNetworkCode', 'priceBucketConfig', 'lineItemNamingConvention', 'pql'],
            optionalKeys: ['companyId', 'creativeIds', 'orderIds', 'inventoryTargeting', 'bidderKeyName', 'pbKeyName', 'bidderValues', 'sizes', 'activateInactiveValues']
        };
    }
    /**
     * Constructs the args object required for the  LineItemCreation -> write_dfp and main wizard;
     * based on the DfpResponse -> dfp_verify
     */
    getLineItemCreationArgs() {
        if (!this.dfpVerifyResponse)
            return null;
        let scriptsArgs = [];
        if (this.dfpVerifyResponse.lineitemsMissing || this.dfpVerifyResponse.cacheFound) { // set wizard args
            let wizardArgs = Object.assign(Object.assign({}, this.getAllLineArgs()), { bidder: this.bidder });
            // we do not check for sizes if no sizes are missing from dfp, to speed up wizard runtime;
            if (!this.dfpVerifyResponse.sizesMissing)
                wizardArgs.checkSizes = false;
            scriptsArgs.push({
                script: 'wizard',
                args: {
                    command: 'main',
                    args: [wizardArgs]
                },
                bidder: this.bidder
            });
            return scriptsArgs;
        }
        else { // set dfp_write script args
            if (this.dfpVerifyResponse.bidderKeyMissing || this.dfpVerifyResponse.bidderValuesMissing) {
                scriptsArgs.push({
                    script: 'write_dfp',
                    args: {
                        command: 'addBidderValues',
                        args: [{
                                dfpNetworkCode: this.lineItemArgs.dfpNetworkCode,
                                bidderKeyName: this.lineItemArgs.bidderKeyName,
                                bidderValues: this.dfpVerifyResponse.missingBidderValues
                            }],
                    },
                    bypassBidderStateVerification: true, // we can bypass bidder state check, since we can run multiple write_dfp commands
                    bidder: this.bidder
                });
            }
            if (this.dfpVerifyResponse.sizesMissing) {
                let sizesArgs = {
                    script: 'write_dfp',
                    args: {
                        command: 'addMissingSizes',
                        args: [{
                                dfpNetworkCode: this.lineItemArgs.dfpNetworkCode,
                                sizes: this.lineItemBidderFormValues.sizes
                            }]
                    },
                    bypassBidderStateVerification: true, // we can bypass bidder state check, since we can run multiple write_dfp commands
                    bidder: this.bidder
                };
                if (this.lineItemArgs.lineItemNamingConvention)
                    sizesArgs.args.args[0].lineItemNamingConvention = this.lineItemArgs.lineItemNamingConvention;
                if (this.lineItemArgs.pql)
                    sizesArgs.args.args[0].pql = this.lineItemArgs.pql;
                scriptsArgs.push(sizesArgs);
            }
            return scriptsArgs;
        }
    }
    /**
     * Retrieve all the valid/non-falsy line automation args to start wizard
     * @returns {any}
     */
    getAllLineArgs() {
        return Object.assign(Object.assign(Object.assign({}, this.validateArgs(this.lineItemArgs).validArgs), this.validateArgs(this.lineItemBidderFormValues).validArgs), this.getDefaultAutoNamingConventions());
    }
    /**
     * Retrieve the selected Arguments values, including only the IDs, for DFP read or the selected value if custom
   * @param {Array<string>} valuesIds
     */
    getSelectedArgsValues(valuesIds) {
        let lineArgsValues = this.lineArgsSelections.reduce((selectedArgs, arg) => {
            if (valuesIds.includes(arg.id)) {
                if (arg.option === 'existing') { //Use the existing values from DB
                    selectedArgs[arg.id] = this.lineItemArgs[arg.id];
                }
                else {
                    if (arg.selectedValues) {
                        selectedArgs[arg.id] = (arg.valuesSelectionType === 'multiple') ? arg.selectedValues.map(values => values.id) : arg.selectedValues.id;
                    }
                    else {
                        selectedArgs[arg.id] = null;
                    }
                }
            }
            return selectedArgs;
        }, {});
        if (valuesIds.includes('inventoryTargeting')) {
            let inventoryTargeting = null;
            if (this.inventoryTargeting.option === 'existing') {
                inventoryTargeting = this.lineItemArgs.inventoryTargeting;
            }
            else if (this.inventoryTargeting.option === 'selectMode') { //Get inventory targeting values
                inventoryTargeting = { mode: this.inventoryTargeting.selectedModeOption };
                if (inventoryTargeting.mode === "ids") {
                    //Get the any selected adunits or placements selected IDs values
                    Object.assign(inventoryTargeting, this.inventoryTargeting.selectIdsOptions.reduce((selectedArgs, arg) => {
                        if (arg.selectedValues) {
                            selectedArgs[arg.id] = arg.selectedValues.map(values => values.id);
                        }
                        return selectedArgs;
                    }, {}));
                }
            }
            lineArgsValues.inventoryTargeting = inventoryTargeting;
        }
        return Object.assign(Object.assign({}, lineArgsValues), this.getDefaultAutoNamingConventions());
    }
    getDefaultAutoNamingConventions() {
        let namingConvs = {};
        for (let namingConv in this.defaultAutoNewNamingConventions) {
            let convention = this.defaultAutoNewNamingConventions[namingConv];
            if (!!convention.value) {
                namingConvs[convention.key] = convention.value;
            }
        }
        return namingConvs;
    }
    setDefaultAutoNamingConventions(lineItemArgs) {
        if (lineItemArgs) {
            for (let namingConv in this.defaultAutoNewNamingConventions) {
                let namingKey = this.defaultAutoNewNamingConventions[namingConv].key;
                if (lineItemArgs[namingKey])
                    this.defaultAutoNewNamingConventions[namingConv].value = lineItemArgs[namingKey];
            }
        }
    }
    /**
     * Format the conventionKey from 'camelCase' to spaced 'Camel Case'
     * @param conventionKey
     */
    getAutoNamingConventionDisplayName(conventionKey) {
        return conventionKey[0].toUpperCase() + conventionKey.slice(1).replace(/[A-Z]/g, (m) => ` ${m}`);
    }
    /**
     * Handles sockets events from main Wizard and write scripts
     * @param event
     */
    onSocketEvent(event) {
        switch (event.status) {
            case 'running':
            case 'data':
                this.lineItemAutomationRunning = true;
                break;
            case 'save':
                this.lineItemAutomationRunning = true;
                //save the returned values
                if (event.data) {
                    this._lineItemAutomation.updateDfpConfigValues(this.bidder, event.data)
                        .then(saved => this.logDebugData('OnSocketEvent - saved item config values received from socket event', event.data))
                        .catch(err => this.logDebugData('OnSocketEvent - unable to save received data from socket event', event.data));
                }
                break;
            case 'finished':
                this.runningWizardScripts[event.scriptName] -= 1;
                if (this.finishedRunningWizardScripts()) { //Verify that we have not displayed those notifications previously on a different 'finished' event
                    event.message = `Line Item Automation Successfully Completed ${event.scriptName || ''}`;
                    this.lineItemAutomationRunning = false;
                    this.resetAllConfigSourcesValues();
                    // Reload to refresh args with latest updated values from wizard;
                    this.loadInitialValues();
                }
                break;
            case 'error':
            case 'invalidArgs':
            case 'failed':
            case 'onFinishedError':
                this.runningWizardScripts[event.scriptName] -= 1;
                this.lineItemAutomationRunning = false;
                break;
        }
        //Log current event state
        this.logLineAutomationEvent(event, event.scriptName);
    }
    /**
     * Handles socket events for DFP verification
     * @param event
     */
    onDfpVerifyEvent(event) {
        switch (event.status) {
            case 'running':
                this.dfpVerificationStatus = 'Running';
                break;
            case 'data':
                if (event.data) {
                    this.dfpVerificationStatus = null;
                    let data = event.data;
                    if (data.lineitemsMissing || data.cacheFound || data.sizesMissing || data.bidderValuesMissing || data.bidderKeyMissing) {
                        // display line config alert to user to select or verify missing values
                        this.dfpVerifyResponse = data;
                        this.verifySelectionsArgsToHide();
                        this.onDfpVerificationFailAlert.emit(this.showDfpVerificationFailAlert = true);
                        this.readyToStartAutomationWizard = false;
                    }
                    else {
                        this.dfpVerificationStatus = 'Passed';
                    }
                }
                break;
            case 'error':
            case 'invalidArgs':
            case 'failed':
            case 'onFinishedError':
                this.dfpVerificationStatus = 'Failed';
                break;
        }
    }
    /**
     * Handles socket events for DFP reads
     * @param event
     */
    onLineItemArgReadEvent(event) {
        switch (event.status) {
            case 'data':
                //Update the values for current selected arg
                //Find the line Args to be update values
                if (event.data && event.data === Object(event.data)) {
                    for (let key in event.data) {
                        if (key !== 'notFound') {
                            let updateSource = "lineArgsSelections";
                            if (key === "adunits" || key === "placements")
                                updateSource = "inventoryTargetingIdOption";
                            if (event.data[key].length > 0) { // if we have data
                                //this._notifier.progress({id:this.notificationId, status: 'Reading DFP Values', message: `Loading DFP values for ${key}`});
                                this.updateLineArgSelection(key, 'values', event.data[key], updateSource);
                                this.updateArgSelectionStatus(key, 'valuesReceived', null, updateSource);
                            }
                            else {
                                this.updateArgSelectionStatus(key, 'noValuesFound', (key === "adunits" || key === "placements") ? '' : `Select 'Auto Create' If you will like this values to be created with the line item automation`, updateSource);
                            }
                        }
                    }
                }
                break;
            case 'finished':
                //If the Read Event that finished is 'adunitMapping', and no values were found on DFP
                //Fallback and Try to get the values using regular 'adunits' read command
                if (event.data && event.data === 'adunitMapping') {
                    //Check if got any values found from DFP already
                    if (!this.inventoryTargeting.selectIdsOptions[this.inventoryTargeting.selectIdsOptions.findIndex((option) => option.id === "adunits")].values) {
                        //Try to READ the DFP values using 'adunits' command
                        this.getDfpLineItemValues('adunits', this.lineItemArgs.dfpNetworkCode, this.lineItemArgs.companyId, null, "inventoryTargetingIdOption");
                    }
                }
                break;
            case 'error':
            case 'invalidArgs':
            case 'failed':
            case 'onFinishedError':
                let updateSource = "lineArgsSelections";
                let command = (event.command === 'adunitMapping') ? 'adunits' : event.command;
                if (command === "adunits" || command === "placements")
                    updateSource = "inventoryTargetingIdOption";
                this.updateArgSelectionStatus(command, 'failed', ' We experienced an internal error retrieving values', updateSource);
                break;
        }
    }
    /**
     * Send request to retrieve line item optional values from line_item_dfp
     * @param {string} commandName
     * @param {number} dfpNetworkCode
     * @param {number} companyId
     */
    getDfpLineItemValues(commandName, dfpNetworkCode, companyId, adunitNames, source = 'lineArgsSelections') {
        this.updateArgSelectionStatus((commandName === 'adunitMapping') ? 'adunits' : commandName, 'searching', null, source);
        this._lineItemAutomation.readDfpValues({ bidder: this.bidder, commandName, dfpNetworkCode, callOnEvent: { fn: this.onLineItemArgReadEvent, context: this }, companyId, adunitNames });
    }
    /**
     * Handle the radio select event for the selected user option for line item configs
     * Based on the selected option retrieve the appropriate DFP values
     * @param option
     */
    handleLineArgSelection(option) {
        let selectedOption = option;
        switch (selectedOption.option) {
            case "select": //Retrieve selectedOption.options from DFP
                //Retrieve values if haven't done so and the companyId has not changed
                if (!selectedOption.values && selectedOption.readCommand) {
                    if (selectedOption.id === "creativeIds" || selectedOption.id === "orderIds") {
                        if (this.lineItemArgs.companyId) {
                            //include companyID
                            this.getDfpLineItemValues(selectedOption.readCommand, this.lineItemArgs.dfpNetworkCode, this.lineItemArgs.companyId);
                        }
                        else { //Alert the user to select company ID
                            this.updateArgSelectionStatus(selectedOption.id, 'missingRequiredArg', `Company ID is required to select ${selectedOption.readCommand}. Please Make sure to first select the companyID.`);
                            this.resetSelectedValues([selectedOption.id], false);
                        }
                    }
                    else {
                        this.getDfpLineItemValues(selectedOption.readCommand, this.lineItemArgs.dfpNetworkCode);
                    }
                }
                break;
            case "generate": //Auto generate values in Python wizard so deleted from line args if exists
                this.resetSelectedValues([selectedOption.id], false, (selectedOption.id === 'inventoryTargeting') ? 'inventoryTargeting' : 'lineArgsSelections');
                break;
            case "existing": //Use existing saved values
                // verify the saved values match the selected current company
                if ((selectedOption.id === "creativeIds" || selectedOption.id === "orderIds") && this.lineItemArgs[selectedOption.id]) {
                    this.verifyAssociatedSavedValues({
                        companyId: this.lineItemArgs.companyId,
                        selectionId: selectedOption.id,
                        savedValues: this.lineItemArgs[selectedOption.id],
                        selectionName: selectedOption.name
                    });
                }
                break;
        }
    }
    /**
     * Click Handler Inventory Targeting RON Mode Selections
     * @param selection
     */
    handleInventoryTargetingMode(selection) {
        if (selection.additionalSelectedOption === 'ron') { //Set selected values to
            this.inventoryTargeting.selectedValues = { "mode": selection.additionalSelectedOption };
        }
    }
    /**
     * Click Handler Inventory Targeting IDs selection
     * @param selection
     */
    handleInventoryTargetingIdSelection(selection) {
        if (selection.option === 'select' && !selection.values) {
            if (selection.id === 'adunits') {
                //Check if we have adUnits names so we can use the "adunitMapping" readCommand
                if (this.lineItemBidderFormValues.adunitNames) {
                    this.getDfpLineItemValues("adunitMapping", this.lineItemArgs.dfpNetworkCode, null, this.lineItemBidderFormValues.adunitNames, "inventoryTargetingIdOption");
                    return;
                }
                else { //Load default ad units
                    this.getDfpLineItemValues(selection.readCommand, this.lineItemArgs.dfpNetworkCode, null, null, "inventoryTargetingIdOption");
                    return;
                }
            }
            //Use default readCommand
            this.getDfpLineItemValues(selection.readCommand, this.lineItemArgs.dfpNetworkCode, null, null, "inventoryTargetingIdOption");
        }
        else { //Option is auto create, reset selected option values
            this.resetSelectedValues([selection.id], false, "inventoryTargetingIdOption");
        }
    }
    /**
     * Receive Emitted selectedValue events from line-item-config inventory targeting Id selections
     * @param {{selectedValues: any; selectedOption: any}} event
     */
    onInventoryIdSelectedValue(event) {
        this.updateLineArgSelection(event.selectedOptionId, 'selectedValues', event.selectedValues, "inventoryTargetingIdOption");
    }
    /**
     * Receive Emitted unselectedValue events from line-item-config inventory targeting Id selections
     * @param {{selectedValues: any; selectedOption: any}} event
     */
    onInventoryIdUnselectedValue(event) {
        this.removeUnselectedLineArgValue(event.selectedOptionId, event.unselectedValue, "inventoryTargetingIdOption");
    }
    /**
     * Click Handler for selected argument values selected from Line Args Config Selection
     * @param selectedValues
     * @param selectedOption
     */
    onSelectedValue(event) {
        this.updateLineArgSelection(event.selectedOptionId, 'selectedValues', event.selectedValues);
    }
    /**
     * Click Handler for unselected argument values selected from Line Args Config Selection
     */
    onUnselectedValue(event) {
        this.removeUnselectedLineArgValue(event.selectedOptionId, event.unselectedValue);
    }
    /**
     * Update the line arguments selected and retrieved Values for given selectionId
     * @param {string} selectionId
     * @param {string} objKey
     * @param newValues
     */
    updateLineArgSelection(selectionId, objKey, newValues, source = 'lineArgsSelections') {
        let selectionIdx = this.lineItemArgsSources[source].findIndex(element => (element.id === selectionId || element.readCommand === selectionId));
        if (selectionIdx !== -1) { //IF we found it
            if (this.lineItemArgsSources[source][selectionIdx].hasOwnProperty(objKey)) {
                //Set the args selection to Array if selection is not set and selection values type is multiple
                if (objKey === 'selectedValues' && !this.lineItemArgsSources[source][selectionIdx].selectedValues && this.lineItemArgsSources[source][selectionIdx].valuesSelectionType === 'multiple') {
                    this.lineItemArgsSources[source][selectionIdx][objKey] = [];
                }
                if (Array.isArray(this.lineItemArgsSources[source][selectionIdx][objKey])) { //push values
                    let currentValues = this.lineItemArgsSources[source][selectionIdx][objKey];
                    let selectedValueIdx = currentValues.findIndex((element) => element.id === newValues.id);
                    if (selectedValueIdx === -1 && newValues) { //If it's not already in values and we values has data
                        currentValues.push(newValues);
                        this.lineItemArgsSources[source][selectionIdx][objKey] = currentValues;
                        //Locate the current value and add selected key so our UI knows which value was selected
                        let valueIdx = this.lineItemArgsSources[source][selectionIdx].values.findIndex((element) => element.id === newValues.id);
                        this.lineItemArgsSources[source][selectionIdx].values[valueIdx]['selected'] = true;
                    }
                }
                else {
                    this.lineItemArgsSources[source][selectionIdx][objKey] = newValues;
                }
            }
        }
    }
    /**
     * Remove the given unSelectedValue from the given 'lineArgsOptionId' 'selectedValues' array
     */
    removeUnselectedLineArgValue(lineArgsOptionId, unselectedValue, source = 'lineArgsSelections') {
        let optionIdx = this.lineItemArgsSources[source].findIndex(option => option.id === lineArgsOptionId);
        let valueIdx = this.lineItemArgsSources[source][optionIdx].values.findIndex(value => value.id === unselectedValue.id);
        let unselectedValueIdx = this.lineItemArgsSources[source][optionIdx].selectedValues.findIndex(value => value.id === unselectedValue.id);
        //Update unselected values selected state
        this.lineItemArgsSources[source][optionIdx].values[valueIdx].selected = false;
        //Remove unSelectedValue from selected values Array.
        this.lineItemArgsSources[source][optionIdx].selectedValues.splice(unselectedValueIdx, 1);
    }
    /**
     * Reset all the selected values for the given selected Args IDs
     * @param {string[]} argsToReset
     */
    resetSelectedValues(resetIds, resetOption, source) {
        return resetIds.forEach((argId) => {
            let idSource = source || this.getIdSource(argId);
            if (argId === 'companyId') {
                this.lineItemArgs.companyId = null;
                this.selectCompanyValues = null;
            }
            else {
                if (Array.isArray(this.lineItemArgsSources[idSource])) {
                    this.lineItemArgsSources[idSource].forEach((selectionArg) => {
                        if (selectionArg.id === argId || selectionArg.name === argId) {
                            selectionArg.selectedValues = null;
                            selectionArg.values = null;
                            if (resetOption)
                                selectionArg.option = '';
                        }
                    });
                }
                else { // it's single source
                    this.lineItemArgsSources[source].selectedValues = null;
                    this.lineItemArgsSources[source].values = null;
                    if (resetOption) {
                        this.lineItemArgsSources[source].option = '';
                        if (this.lineItemArgsSources[source].selectedModeOption)
                            this.lineItemArgsSources[source].selectedModeOption = '';
                    }
                }
            }
        });
    }
    ;
    /**
     * Resets all the selected config values from all sources Ids
     */
    resetAllConfigSourcesValues() {
        this.resetSelectedValues(['orderIds', 'creativeIds'], true, 'lineArgsSelections');
        this.resetSelectedValues(['adunits', 'placements'], true, 'inventoryTargetingIdOption');
        this.resetSelectedValues(['inventoryTargeting'], true, 'inventoryTargeting');
    }
    /**
     * Update the status of line item arg selected
     */
    updateArgSelectionStatus(selectionId, status, msg, source = 'lineArgsSelections') {
        let selectionIdx = this.lineItemArgsSources[source].findIndex(element => (element.id === selectionId || element.readCommand === selectionId));
        if (selectionIdx !== -1)
            this.lineItemArgsSources[source][selectionIdx].status = { name: status, msg: msg };
    }
    ;
    /**
     * Open the current tab for line item args selection
     * @param {string} tab
     */
    openTab(tab) {
        //Reset the current open tab
        for (let openTab in this.tabsetOpen) {
            if (this.tabsetOpen[openTab]) {
                this.tabsetOpen[openTab] = false;
            }
        }
        //Set the new tab
        this.tabsetOpen[tab] = true;
    }
    /**
     * Close DPF verification alert
     */
    onCloseDfpVerificationAlert() {
        this.showDfpVerificationFailAlert = false;
        this.onDfpVerificationFailAlert.emit(this.showDfpVerificationFailAlert);
    }
    /**
     * Click handler to scroll to line args selection
     */
    onFixLineItemConfigs(deleteCacheConfigs) {
        if (!deleteCacheConfigs && this.dfpVerifyResponse && this.dfpVerifyResponse.cacheFound) {
            this.showDfpVerificationFailAlert = false;
            // we just need to run wizard
            this.startLineItemAutomation(this.getLineItemCreationArgs());
            return void 0;
        }
        // Prompt user for confirmation of deleting cache 
        if (deleteCacheConfigs) {
            this._talk.confirm(`<h2>Are you sure you want to delete the existing cached configs for this bidder?</h2>
      <p>If you proceed, any of the values that were in progress during the Line Item Creation won't be synced to DFP.</p>`)
                .then(resultPromise => {
                if (resultPromise.result) {
                    return resultPromise.result.then(result => {
                        if (result) {
                            // proceed to delete cache file
                            this.dfpVerifyResponse.cacheFound = false;
                            this._lineItemAutomation.deleteCacheFile(this.bidder)
                                .then(deleted => this.startLineItemDfpVerify(this.bidder))
                                .catch(err => {
                                this._talk.broadcast(`<p><strong>Unable to delete cache file. Please try running verification again.</strong></p> 
                  <p>If this problem persits please submit a support request and our team will assist you.</p>`);
                            });
                        }
                        this.showDfpVerificationFailAlert = false;
                    }).catch(err => {
                        this.showDfpVerificationFailAlert = false;
                    });
                }
            });
            return void 0;
        }
        this.showArgsSelection = true;
        //We need to defer the scrolling until the line args selection Element it's re-added to the DOM by NG
        //so that we can access the nativeElement
        setTimeout(() => {
            this.showDfpVerificationFailAlert = false;
            //Pass the current args selection element top offset + additional 1250 offset
            this.doScrolling(this.argsSelection.nativeElement, 3000);
        }, 0);
    }
    /**
     * Scroll the window view to the given element Y offset position withing x duration time
     * @param elementY
     * @param duration
     */
    doScrolling(element, duration, extraYOffset = 1250) {
        if (!element)
            return this.logDebugData('Unable to do scrolling, No element provided');
        // Get the current window and element and window Y/Height coordinates
        let elementOffsetTop = element.getBoundingClientRect().top;
        let windowScrollY = window.parent.scrollY;
        let elementY = (elementOffsetTop === 0) ? elementOffsetTop + extraYOffset : (elementOffsetTop + windowScrollY);
        const startingY = window.parent.pageYOffset;
        const diff = elementY - startingY;
        let start;
        window.parent.requestAnimationFrame(function step(timestamp) {
            start = (!start) ? timestamp : start;
            let time = timestamp - start;
            let percent = Math.min(time / duration, 1);
            window.parent.scrollTo(0, startingY + diff * percent);
            if (time < duration) {
                window.parent.requestAnimationFrame(step);
            }
        });
    }
    /**
     * COMPANy ID SELECTION
     */
    changeCompanyIdHandler() {
        this._lineItemAutomation.readDfpValues({ bidder: this.bidder, commandName: 'companies', dfpNetworkCode: this.lineItemArgs.dfpNetworkCode, callOnEvent: { fn: this.onCompanyReadEvent, context: this } });
        this.loadingCompanyValues = true;
    }
    /**
     * Handle socket events for company ID Reads
     * @param event
     */
    onCompanyReadEvent(event) {
        switch (event.status) {
            case 'data':
                if (event.data && event.data === Object(event.data)) {
                    for (let key in event.data) {
                        if (key === 'companies') { //For now only check for companies// exclude 'progress';
                            this.loadingCompanyValues = false;
                            if (event.data[key].length > 0) { // if we have data
                                let foundCompanies = event.data[key];
                                //Find the this company and mark as selected for dropdown
                                let companyIdx = this.lineItemArgs.companyId ? foundCompanies.findIndex((company) => company.id === this.lineItemArgs.companyId) : -1;
                                if (companyIdx !== -1)
                                    foundCompanies[companyIdx].selected = true;
                                // default to null/ Auto Create
                                else
                                    this.lineItemArgs.companyId = null;
                                this.selectCompanyValues = foundCompanies;
                            }
                            else {
                                this._talk.broadcast(`<h1> No Companies Found </h1> <p>We did not find any companies related to the provide DFP Network Code(${this.lineItemArgs.dfpNetworkCode})</p>`);
                            }
                        }
                    }
                }
                break;
            case 'error':
            case 'invalidArgs':
            case 'failed':
            case 'onFinishedError':
                this.loadingCompanyValues = false;
                this.logLineAutomationEvent(event, 'Read Dfp Companies');
                break;
        }
    }
    /**
     * Handler for company selection changes, verify we can change companyId if no other orders/creative Ids are selected
     * @param {String} selected
     */
    onCompanyChange($event, selected) {
        let selectedCompanyId = (selected && selected !== 'null') ? parseInt(selected) : null;
        //Update if no company has been set previously
        if (!this.lineItemArgs.companyId)
            return (this.lineItemArgs.companyId = selectedCompanyId);
        //Check if company changed
        if (selectedCompanyId !== this.lineItemArgs.companyId) {
            let resetKeys = this.companyIdUpdateCheck(selectedCompanyId);
            if (resetKeys.length > 0) {
                this._talk.confirm(`<h1>Confirm Company ID Change</h1><p>You currently have loaded values for <strong>${resetKeys.toString()}</strong> with a different company Id.</p>
													<p>If you proceed, you will need to reselect/load the values.</p>`)
                    .then(resultPromise => {
                    if (resultPromise.result)
                        return resultPromise.result
                            .then(result => {
                            if (result) {
                                this.resetSelectedValues(resetKeys, true);
                                this.lineItemArgs.companyId = selectedCompanyId;
                            }
                        });
                }).catch(err => {
                    //Revert selected company option
                    $event.target.value = this.lineItemArgs.companyId;
                });
            }
            else { //We can update company Id
                this.lineItemArgs.companyId = selectedCompanyId;
            }
        }
    }
    /**
     * Verify if we require any args to be reset before updating company
     */
    companyIdUpdateCheck(selectedCompanyId) {
        let requiredResetKeys = [];
        //check if LineArgsSelection it's on and if there is any creatives or orders already selected
        if (this.showArgsSelection) {
            let orders = this.verifyValues('orderIds');
            let creatives = this.verifyValues('creativeIds');
            if (orders.hasLoadedValues || orders.hasExistingValues)
                requiredResetKeys.push('orderIds');
            if (creatives.hasLoadedValues || creatives.hasExistingValues)
                requiredResetKeys.push('creativeIds');
        }
        return requiredResetKeys;
    }
    /**
     * Handle changes for new selected DfpNetwork Code, verify the user if ever to perform change
     */
    onNetworkCodeChange($event, selectedNetworkCode) {
        if (this.lineItemArgs.dfpNetworkCode && this.lineItemArgs.dfpNetworkCode === parseInt(selectedNetworkCode)) {
            this.showDfpNetworkSelection = false;
            return;
        }
        if (this.lineItemAutomationRunning)
            return this._talk.broadcast('<h2>You cannot change DFP Network Code </h2><p>LineItem Automation Wizard is already running for another Network Code.</p>');
        let valuesToReset = this.checkValuesForReset();
        if (valuesToReset.length > 0) {
            this._talk.confirm(`<h2>Verify DFP Network Code Change</h2> 
      <p>If you proceed with this change, the values for <strong>${valuesToReset.toString()}</strong> will be reset and LineItem DFP Verification will be restarted.</p>`)
                .then(resultPromise => {
                if (resultPromise.result)
                    return resultPromise.result
                        .then(result => {
                        if (result) {
                            this.lineItemArgs.dfpNetworkCode = parseInt(selectedNetworkCode);
                            this.showArgsSelection = false;
                            this.showDfpNetworkSelection = false;
                            Promise.resolve(this.resetSelectedValues(valuesToReset, true))
                                .then(() => {
                                this.onTriggerBidderSave.emit(true);
                            });
                        }
                    });
            }).catch(cancelledOrClosed => {
                //Reset selected value
                $event.target.value = this.lineItemArgs.dfpNetworkCode;
                this.showDfpNetworkSelection = false;
            });
        }
        else { //We are able change dfpNetwork
            this.lineItemArgs.dfpNetworkCode = parseInt(selectedNetworkCode);
            this.showDfpNetworkSelection = false;
        }
    }
    onAuthorizeDfpVerify(runningAsPending = false) {
        if (this.verifyRequiredLineItemArgs(false)) {
            // TODO : check pending notifications
            // if (this.dfpVerificationsRunning()) this.addPendingDfpTask('onAuthorizeDfpVerify')
            // if these is new bidder; Dfp Read will be triggered after bidder save completion
            this.onTriggerBidderSave.emit(true);
        }
    }
    /**
     * Logs and starts notification progress(*if received) for given socket event
     * @param event
     */
    logLineAutomationEvent(event, logName) {
        let logStr = logName || this.notificationTitle;
        let defaultResetFields = { error: null, htmlContent: null, clickableContent: null };
        switch (event.status) {
            case 'running':
                event.status = `${logStr}: running`;
                this._notifier.progress(Object.assign(Object.assign({}, defaultResetFields), { id: this.notificationId, type: 'info', status: event.status, message: event.message }));
                break;
            case 'data':
                if (event.data && event.data.progress) { //find any progress counts
                    let progressData = event.data.progress;
                    if (progressData && progressData === Object(progressData)) {
                        let total = 0;
                        let completed = 0;
                        let progressValues = "";
                        for (let progress in progressData) {
                            progressValues += `${progress}; `;
                            if (progressData[progress].total)
                                total += progressData[progress].total;
                            if (progressData[progress].completed)
                                completed += progressData[progress].completed;
                        }
                        //Start the notifier progress bar, if not started
                        if (total && !this._notifier.total(this.notificationId)) {
                            this._notifier.startProgress(Object.assign(Object.assign({}, defaultResetFields), { id: this.notificationId, status: 'Starting to process data', type: 'info', loadTotal: total }));
                        }
                        //Update the notifier total if it changed
                        let currentTotal = this._notifier.total(this.notificationId);
                        if (currentTotal && currentTotal !== total) {
                            this._notifier.updateTotal(this.notificationId, total);
                        }
                        this._notifier.progress(Object.assign(Object.assign({}, defaultResetFields), { type: 'info', id: this.notificationId, status: `${logStr} processing: ${progressValues}`, message: event.message }), completed);
                    }
                }
                else {
                    this._notifier.progress(Object.assign(Object.assign({}, defaultResetFields), { type: 'info', id: this.notificationId, status: `${logStr} processing data.`, message: event.message }));
                }
                break;
            case 'error':
            case 'invalidArgs':
            case 'failed':
            case 'onFinishedError':
                this._notifier.progress(Object.assign(Object.assign({}, defaultResetFields), { type: 'error', id: this.notificationId, status: `${logStr} Error.`, message: event.message || `We had an internal problem running ${logStr}` }));
                break;
            default:
                this._notifier.progress(Object.assign(Object.assign({}, defaultResetFields), { type: 'info', id: this.notificationId, status: `${logStr}: ${event.status}`, message: event.message }));
        }
    }
    finishedRunningWizardScripts() {
        let runningTotal = 0;
        for (let c in this.runningWizardScripts) {
            runningTotal += (typeof this.runningWizardScripts[c] === 'number') ? this.runningWizardScripts[c] : 0;
        }
        return runningTotal === 0;
    }
    /**
     * VALIDATORS
     */
    /**
     * Verify the required args for line item automation and notify user if missing values
     * @returns Boolean
     */
    verifyRequiredLineItemArgs(checkPriceBucket = true, keysToVerify) {
        let missingArgsMsg = "";
        keysToVerify = keysToVerify || this.getDefaultVerificationKeys().requiredKeys;
        keysToVerify.forEach(verifyKey => {
            if (verifyKey === 'lineItemNamingConvention') {
                if (verifyKey === 'lineItemNamingConvention' && !this.lineItemArgs.lineItemNamingConvention) {
                    missingArgsMsg += "<li>lineItemNamingConvention is required.</li>";
                }
                if (this.lineItemArgs.lineItemNamingConvention && this.invalidLineItemNamingConv) {
                    missingArgsMsg += "<li>Invalid lineItemNamingConvention. lineItemNamingConvention must contain %s.</li>";
                }
            }
            if (verifyKey === 'pql' && this.lineItemArgs.pql && this.validatedPqlQuery.isInvalid) {
                missingArgsMsg += "<li>Invalid PQL Query. Please enter a valid PQL Query String.</li>";
            }
            if (verifyKey === 'dfpNetworkCode' && !this.lineItemArgs.dfpNetworkCode)
                missingArgsMsg += "<li>A valid DFP Network Code is required </li>";
            if (verifyKey === 'priceBucketConfig' && checkPriceBucket && !this.lineItemBidderFormValues.priceBucketConfig)
                missingArgsMsg += "<li>Price Buckets Config Values missing.</li>";
            if (verifyKey === 'bidderKeyName' && !this.lineItemArgs.bidderKeyName)
                missingArgsMsg += "<li>Missing Bidder Key Name. </li>";
            if (verifyKey === 'bidderValues' && !this.lineItemArgs.bidderValues)
                missingArgsMsg += "<li>Missing Demand Partners values. </li>";
        });
        if (this.dfpVerifyResponse && this.dfpVerifyResponse.inactiveValuesFound && !this.lineItemArgs.activateInactiveValues) {
            missingArgsMsg += "<li>Permission to Activate Inactive Values is required </li>";
        }
        //1.1if missing required args notify user
        if (missingArgsMsg) {
            this.displayValidationError(missingArgsMsg);
        }
        return !missingArgsMsg;
    }
    displayValidationError(missingArgsMsg) {
        this._talk.broadcast(`
      <p>Missing Required Arguments for Line Item Automation Service </p>
      <ul>${missingArgsMsg}</ul>
      <p> Please make sure to provide or fix the value/s for line item automation.</p>
    `);
    }
    processPendingPostDfpTasks() {
        if (this.pendingTasksPostDfpVerification.length) {
            this.logDebugData('pending tasks', this.pendingTasksPostDfpVerification);
            // execute the pendind tasks
            for (let idx = this.pendingTasksPostDfpVerification.length - 1; idx >= 0; --idx) {
                this.logDebugData('checking pending tasks', [idx, this.pendingTasksPostDfpVerification[idx], !!this[this.pendingTasksPostDfpVerification[idx]]]);
                if (!!this[this.pendingTasksPostDfpVerification[idx]]) {
                    let taskFn = this.pendingTasksPostDfpVerification[idx];
                    this[taskFn]();
                    this.pendingTasksPostDfpVerification.pop();
                    this.logDebugData('running pending task', taskFn);
                }
            }
        }
    }
    addPendingDfpTask(taskFn) {
        if (taskFn && this.pendingTasksPostDfpVerification.indexOf(taskFn) === -1) {
            this.pendingTasksPostDfpVerification.push(taskFn);
        }
    }
    dfpVerificationsRunning() {
        if (this.loadingCompanyValues || this.verifyingPqlQuery || this.verifyingSavedValues['orderIds'] || this.verifyingSavedValues['creativeIds']) {
            this._talk.broadcast('There are DFP verifications currently running. Please wait for verifications to complete to continue.');
            return true;
        }
        return false;
    }
    /**
     * Verify that all verifications for selected arguments passed
   * @param {Array<string>} idsToCheck
     * @returns Boolean
     */
    verifySelectedLineItemArgs(idsToCheck) {
        let missingArgsMsg = "", defaultKeys;
        idsToCheck = idsToCheck || (defaultKeys = this.getDefaultVerificationKeys(), [...defaultKeys.requiredKeys, ...defaultKeys.optionalKeys]);
        //Check if lineargs had any option selected
        this.lineArgsSelections.forEach((selection) => {
            if (idsToCheck.includes(selection.id)) {
                if (selection.valuesSelectionType == 'multiple' && !selection.option) {
                    missingArgsMsg += `<li>No option was selected for ${selection.name}.</li>`;
                }
                //Make sure the user selected some values
                if (selection.valuesSelectionType == 'multiple' && selection.option === 'select' && (selection.values && !selection.selectedValues)) {
                    missingArgsMsg += `<li>No ${selection.name} values were selected. You must select at least one value if 'Select Values' option is enabled.</li>`;
                }
                if (selection.valuesSelectionType === 'input' && selection.option === 'existing' && !this.lineItemArgs[selection.id]) {
                    missingArgsMsg += `<li>No value was provided for ${selection.name}.</li>`;
                }
            }
        });
        //Check inventory targeting options
        if (idsToCheck.includes('inventoryTargeting')) {
            if (!this.inventoryTargeting.option) {
                missingArgsMsg += `<li>No option was selected for ${this.inventoryTargeting.name}.</li>`;
            }
            else if (this.inventoryTargeting.option === 'selectMode' && !this.inventoryTargeting.selectedModeOption) {
                missingArgsMsg += `<li>A Mode option is required for ${this.inventoryTargeting.name}.</li>`;
            }
            else if (this.inventoryTargeting.option === 'selectMode' && this.inventoryTargeting.selectedModeOption === 'ids') {
                //CHeck if one of the required IDs options was selected
                missingArgsMsg += this.inventoryTargeting.selectIdsOptions.reduce((missing, selection, idx) => {
                    if (!selection.option)
                        missing.count++;
                    if (idx === this.inventoryTargeting.selectIdsOptions.length - 1 && missing.count === this.inventoryTargeting.selectIdsOptions.length) {
                        missing.msg = `<li>At least one Inventory Targeting Id selection (Ad Units and/or Placements) values are required.</li>`;
                    }
                    else if (selection.option && (selection.values && !(selection.selectedValues && selection.selectedValues.length > 0))) {
                        missing.msg += `<li>No values were selected for ${selection.name} in Inventory Targeting IDs.</li>`;
                    }
                    return missing;
                }, { count: 0, msg: "" }).msg;
            }
        }
        if (missingArgsMsg) { //missing required args notify user
            this.displayValidationError(missingArgsMsg);
        }
        return !missingArgsMsg;
    }
    onSetInactivateValue(value) {
        this.lineItemArgs.activateInactiveValues = value;
    }
    validateLineItemNamingConv() {
        //Make sure the str contains %s
        if (this.lineItemArgs.lineItemNamingConvention) {
            this.invalidLineItemNamingConv = !(/(%s)/g.test(this.lineItemArgs.lineItemNamingConvention));
            return this.invalidLineItemNamingConv;
        }
        else {
            this.invalidLineItemNamingConv = false;
        }
    }
    validatePqlStr(initialVerifyState = true) {
        if (this.lineItemArgs.dfpNetworkCode && this.lineItemArgs.pql) {
            this.verifyingPqlQuery = initialVerifyState;
            this._lineItemAutomation.readDfpValues({ bidder: this.bidder, commandName: 'pqlValidate', dfpNetworkCode: this.lineItemArgs.dfpNetworkCode, callOnEvent: { fn: this.onPqlValidateReadEvent, context: this }, pql: this.lineItemArgs.pql });
        }
        else {
            this.validatedPqlQuery.isInvalid = false;
        }
    }
    onPqlValidateReadEvent(event) {
        switch (event.status) {
            case 'running':
                this.verifyingPqlQuery = true;
                break;
            case 'data':
                this.verifyingPqlQuery = false;
                if (event.data && event.data === Object(event.data)) {
                    this.validatedPqlQuery.isInvalid = !event.data.valid;
                    if (this.validatedPqlQuery.isInvalid) {
                        this.displayValidationError("<li>Invalid PQL Query. Please enter a valid PQL Query String.</li>");
                    }
                }
                this.processPendingPostDfpTasks();
                break;
            case 'error':
            case 'invalidArgs':
            case 'failed':
            case 'onFinishedError':
                this.verifyingPqlQuery = false;
                this.logLineAutomationEvent(event, 'PQL Verification');
                break;
        }
    }
    /**
     * Validate saved values for creatives and orders of a company ID
     */
    verifyAssociatedSavedValues({ companyId, selectionId, selectionName, savedValues, }) {
        if (companyId && selectionId && savedValues) {
            let commandName;
            if (selectionId === 'orderIds')
                commandName = 'validateOrderCompany';
            else if (selectionId === 'creativeIds')
                commandName = 'validateCreativeCompany';
            let verifyArgs = {
                bidder: this.bidder,
                commandName,
                companyId,
                dfpNetworkCode: this.lineItemArgs.dfpNetworkCode,
                [selectionId]: savedValues,
                callOnEvent: { fn: (e) => { this.onverifyAssociatedSavedReadEvent(e, selectionId, selectionName); }, context: this },
            };
            this._lineItemAutomation.readDfpValues(verifyArgs);
        }
    }
    onverifyAssociatedSavedReadEvent(event, selectionId, selectionName) {
        switch (event.status) {
            case 'running':
                this.verifyingSavedValues[selectionId] = true;
                break;
            case 'data':
                this.verifyingSavedValues[selectionId] = false;
                if (event.data && !event.data.valid) {
                    this._talk.broadcast(`<p>The existing <b>${selectionName || selectionId}</b> saved values are no longer valid. Please select or auto create the values. </p>`);
                    this.resetSelectedValues([selectionId], true);
                    this.lineItemArgs[selectionId] = null;
                }
            default:
                this.verifyingSavedValues[selectionId] = false;
                break;
        }
    }
    /**
     * Validate if given args Object has properties missing values
     * @param args
     * @returns {{args: any; missingArgs: Array}}
     */
    validateArgs(args) {
        let missingArgs = [];
        let validArgs = {};
        //Verify all args have values
        for (let arg in args) {
            if (typeof args[arg] !== 'boolean' && !args[arg])
                missingArgs.push(arg);
            else
                validArgs[arg] = args[arg];
        }
        return {
            validArgs,
            missingArgs
        };
    }
    /**
     * Verify if given Line Item selection Id has selectedValues or loadValues
     * @param {string} selectorId
     * @param {string} source
     * @returns {boolean}
     */
    verifyValues(selectorId, source) {
        let idSource = source || this.getIdSource(selectorId);
        let idx = this.lineItemArgsSources[idSource].findIndex(selection => selection.id === selectorId);
        let selection = this.lineItemArgsSources[idSource][idx];
        return {
            hasLoadedValues: selection ? !!selection.values : false,
            hasSelectedValues: selection ? (selection.option === 'select' && (selection.values && (selection.selectedValues && selection.selectedValues.length > 0))) : false,
            hasExistingValues: selection ? (selection.option == 'existing' && this.lineItemArgs[selection.id]) : false
        };
    }
    getIdSource(selectorId) {
        const IDS_SOURCES = {
            'orderIds': 'lineArgsSelections',
            'creativeIds': 'lineArgsSelections',
            'adunits': 'inventoryTargetingIdOption',
            'placements': 'inventoryTargetingIdOption',
            'inventoryTargeting': 'inventoryTargeting'
        };
        return IDS_SOURCES[selectorId];
    }
    verifySelectionsArgsToHide() {
        this.lineArgsSelections.forEach(selection => {
            selection.customClass = !this.verifySelectionDisplayPermission(selection) ? 'hidden' : '';
        });
        this.inventoryTargeting.customClass = !this.verifySelectionDisplayPermission(this.inventoryTargeting) ? 'hidden' : '';
    }
    verifySelectionDisplayPermission(selection) {
        if (selection && !selection.displayPermissions)
            return true;
        let permissions = selection.displayPermissions || [];
        // If the lines items are missing all args should be displayed
        if (permissions.length && permissions.includes('lineitemsMissing') && this.dfpVerifyResponse['lineitemsMissing'])
            return true;
        // verify selection have any other permissions
        let passed = permissions.reduce((total, perm) => {
            if (this.dfpVerifyResponse[perm])
                total++;
            return total;
        }, 0);
        return (passed >= 1);
    }
    checkValuesForReset() {
        let valuesToReset = [];
        if (this.lineItemArgs.companyId && this.selectCompanyValues)
            valuesToReset.push('companyId');
        if (this.showArgsSelection && this.verifyValues('orderIds').hasLoadedValues)
            valuesToReset.push('orderIds');
        if (this.showArgsSelection && this.verifyValues('creativeIds').hasLoadedValues)
            valuesToReset.push('creativeIds');
        if (this.showArgsSelection && this.verifyValues('adunits').hasLoadedValues)
            valuesToReset.push('adunits');
        if (this.showArgsSelection && this.verifyValues('placements').hasLoadedValues)
            valuesToReset.push('placements');
        return valuesToReset;
    }
    canDisplayLineItemConfig(configArgId, dfpVerifyRestrictions) {
        if (configArgId && dfpVerifyRestrictions && this.dfpVerifyResponse) {
            return !!this.dfpVerifyResponse[configArgId];
        }
        return true;
    }
    logDebugData(msg, data) {
        if (this._lineItemAutomation.canLogDebugData()) {
            console.log(msg, data);
        }
    }
    /**
     *
     */
    /**
     * HELP MODELS
     */
    dfpNetworkCodeHelp() {
        this._talk.broadcast("The DFP Network Code represents the unique Network Code ID for your DFP instance.");
    }
    lineItemNamingConvHelp() {
        this._talk.broadcast("The Line Item Naming Convention is used to avoid multiple line items targeting the same price bucket.");
    }
    pqlQueryHelp() {
        this._talk.broadcast(`The PQL(Publisher Query Language) Query. Gives you a deeper control into how the line items should be targeted and retrieved from DFP. It's more flexible than the line item naming convention. 
      <h4>How to write PQL Query?</h4> <a href="${this.pqlInfoUrl}" target="_blank" rel="external">Learn more about PQL.</a>`);
    }
    companyIdHelp() {
        this._talk.broadcast(`The company ID represents the company the line items will belong to. You will be able to select the companies that belong to the provided DFP Network Code. " + 
			<p>If no company is selected or 'Auto Create Company ID' option is selected we will auto create the company for you.</p>`);
    }
    newAutoNamingConventionHelp(keyName) {
        this._talk.broadcast(`This is the default naming convention that will be used when creating new <b>${keyName}</b> value/s. 
    In order to avoid name collisions a number is appended to the naming convention if a duplicate naming convention name is detected.</p>`);
    }
    activateInactiveValuesHelp() {
        this._talk.broadcast(`<p>This gives us your permission to reactivate any required pb values that are inactive. </p>`);
    }
};
exports.LineItemAutomationComponent = LineItemAutomationComponent;
__decorate([
    (0, core_1.ViewChild)('argsSelection'),
    __metadata("design:type", core_1.ElementRef)
], LineItemAutomationComponent.prototype, "argsSelection", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], LineItemAutomationComponent.prototype, "onDfpVerificationFailAlert", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], LineItemAutomationComponent.prototype, "onTriggerBidderSave", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Number)
], LineItemAutomationComponent.prototype, "bidder", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], LineItemAutomationComponent.prototype, "bidderLocked", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], LineItemAutomationComponent.prototype, "priceBucketConfig", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], LineItemAutomationComponent.prototype, "adUnits", void 0);
exports.LineItemAutomationComponent = LineItemAutomationComponent = __decorate([
    (0, core_1.Component)({
        selector: 'line-item-automation',
        templateUrl: 'app/lineitem-automation.component.html',
        styleUrls: ['styles/less/lineitem-automation.component.less']
    }),
    __metadata("design:paramtypes", [lineitem_automation_service_1.LineAutomationService,
        notification_service_1.NotificationService,
        notifier_service_1.NotifierService,
        user_service_1.UserService])
], LineItemAutomationComponent);
//# sourceMappingURL=lineitem-automation.component.js.map